<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import { ApiRoutes } from "$src/infrastructure/apiConfig/ApiRoutes";
  import { hubStore } from "$src/application/realtime/hubStore";
  import { HubService } from "$src/application/realtime/HubService";

  const hub = new HubService(ApiRoutes.HUB.endpoint());

  onMount(async () => {
    await hub.start();
    hubStore.set(hub);
  });


  onDestroy(async () => {
    if (hub) {
      await hub.stop();
      hubStore.set(null);
    }
  });
</script>

<slot></slot>
